// extracted by mini-css-extract-plugin
export default {"brand":"BrandWord_brand__KTTn1","word":"BrandWord_word__xn1nK","num":"BrandWord_num__VtAwR"};